var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { GARDEN_FURNITURE_CATEGORY_SLUG, } from '@declaration/store/personalProperty';
import { InsurerFeatureFlag, insurerHasFeature } from '@shared/featureFlags/insurerFeatureFlags';
const personalProperty = namespace('personalProperty');
const settings = namespace('settings');
const layout = namespace('layout');
let PersonalPropertyCategorySelect = class PersonalPropertyCategorySelect extends Vue {
    get selfCareSettings() {
        return this.setting('selfCareSettings');
    }
    get categoryIRI() {
        return this.value;
    }
    set categoryIRI(iri) {
        this.$emit('input', iri);
    }
    get hiddenCategories() {
        var _a, _b, _c, _d, _e;
        const hiddenConfig = (_b = (_a = this.selfCareSettings) === null || _a === void 0 ? void 0 : _a.declaration) === null || _b === void 0 ? void 0 : _b.HiddenInitialPersonalPropertyCategories;
        const baseHidden = [];
        if (hiddenConfig) {
            baseHidden.push(...((_c = hiddenConfig.shared) !== null && _c !== void 0 ? _c : []));
            baseHidden.push(...((_e = (_d = hiddenConfig.trigrams) === null || _d === void 0 ? void 0 : _d[this.trigram]) !== null && _e !== void 0 ? _e : []));
        }
        if (insurerHasFeature(InsurerFeatureFlag.GardenFurnitureAsPersonalProperty, this.trigram)) {
            baseHidden.push(GARDEN_FURNITURE_CATEGORY_SLUG);
        }
        return baseHidden;
    }
    get filteredCategories() {
        return this.categories.filter((category) => !category.data.isHidden && !this.hiddenCategories.includes(category.data.slug));
    }
    visibleSubcategories(subcategories) {
        return subcategories.filter((category) => !category.isHidden && !this.hiddenCategories.includes(category.slug));
    }
};
__decorate([
    personalProperty.State('categories')
], PersonalPropertyCategorySelect.prototype, "categories", void 0);
__decorate([
    personalProperty.State('categoriesByIri')
], PersonalPropertyCategorySelect.prototype, "categoriesByIri", void 0);
__decorate([
    settings.Getter('setting')
], PersonalPropertyCategorySelect.prototype, "setting", void 0);
__decorate([
    layout.State('isMobile')
], PersonalPropertyCategorySelect.prototype, "isMobile", void 0);
PersonalPropertyCategorySelect = __decorate([
    Component({
        components: {},
        props: {
            value: { type: String, default: null },
            trigram: { type: String, required: true },
        },
    })
], PersonalPropertyCategorySelect);
export default PersonalPropertyCategorySelect;
